var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1537_6186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8696 14.1803C32.8696 12.1342 27.3089 10.4298 19.9177 10.0353V6.77695H29.1475V0H3.90685V6.77695H13.1367V10.0515C5.87973 10.4705 0.449219 12.1586 0.449219 14.1803C0.449219 16.198 5.87566 17.8861 13.1326 18.3092V30.0041H19.9096V18.3214C27.3048 17.9268 32.8696 16.2224 32.8696 14.1803ZM16.6594 16.1939C8.72719 16.1939 2.29193 14.9654 2.29193 13.4522C2.29193 12.1708 6.90481 11.0929 13.1326 10.7919V11.5647V14.7254C14.2553 14.7864 15.435 14.8231 16.6553 14.8231C17.778 14.8231 18.8682 14.7946 19.9096 14.7417V10.7756C26.2757 11.0563 31.0187 12.1464 31.0187 13.4481C31.0268 14.9654 24.5916 16.1939 16.6594 16.1939Z",
    fill: "#290E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1537_6186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5424,
    height: 30,
    fill: "white",
    transform: "translate(0.310547)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDark);
export default __webpack_public_path__ + "static/media/token-dark.97b4e5e530745a06874e6048f5fe306a.svg";
export { ForwardRef as ReactComponent };